"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabTitleFromFilter = exports.tabFromFilter = exports.displayTextFromFilter = exports.MediaSorts = exports.MediaTabs = exports.DocumentFilterNames = exports.MediaFilterNames = exports.ImageFilterNames = exports.MediaItemFilterNames = void 0;
var MediaContext_1 = require("./MediaContext");
exports.MediaItemFilterNames = [
    'comment_media',
    'custom_bullet_image',
    'guide_main_image',
    'guide_step_image',
    'guide_step_object',
    'guide_step_video',
    'guide_step_embed',
    'guide_document',
    'profile_image',
    'wiki_summary_image',
    'site_image',
    'wiki_media',
    'work_order_document',
    'work_order_image',
    'work_order_object',
];
exports.ImageFilterNames = [
    'comment_media',
    'custom_bullet_image',
    'guide_main_image',
    'guide_step_image',
    'profile_image',
    'site_image',
    'wiki_summary_image',
    'work_order_image',
];
exports.MediaFilterNames = [
    'comment_media',
    'guide_step_embed',
    'guide_step_object',
    'guide_step_video',
    'wiki_media',
    'work_order_object',
];
exports.DocumentFilterNames = ['guide_document', 'work_order_document'];
exports.MediaTabs = {
    All: 'all',
    Images: 'images',
    Documents: 'documents',
    Media: 'media',
};
exports.MediaSorts = {
    AZ: 'a-z',
    Date: 'date',
};
var displayTextFromFilter = function (_js, filter) {
    switch (filter) {
        case 'comment_media':
            return _js('comment media');
        case 'custom_bullet_image':
            return _js('custom bullet image');
        case 'guide_main_image':
            return _js('guide main image');
        case 'guide_step_image':
            return _js('guide step image');
        case 'guide_step_object':
            return _js('guide step object');
        case 'guide_step_video':
            return _js('guide step video');
        case 'guide_step_embed':
            return _js('guide step embed');
        case 'guide_document':
            return _js('guide document');
        case 'profile_image':
            return _js('profile image');
        case 'wiki_summary_image':
            return _js('wiki summary image');
        case 'site_image':
            return _js('site image');
        case 'wiki_media':
            return _js('wiki media');
        case 'work_order_image':
            return _js('work order image');
        case 'work_order_object':
            return _js('work order object');
        case 'work_order_document':
            return _js('work order document');
        default:
            return '';
    }
};
exports.displayTextFromFilter = displayTextFromFilter;
var tabFromFilter = function () {
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    if (mediaContext.filter) {
        if (exports.ImageFilterNames.includes(mediaContext.filter)) {
            return exports.MediaTabs.All;
        }
        if (exports.MediaFilterNames.includes(mediaContext.filter)) {
            return exports.MediaTabs.Media;
        }
        if (exports.DocumentFilterNames.includes(mediaContext.filter)) {
            return exports.MediaTabs.Documents;
        }
    }
    return exports.MediaTabs.All;
};
exports.tabFromFilter = tabFromFilter;
var tabTitleFromFilter = function () {
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    if (mediaContext.filter) {
        if (exports.ImageFilterNames.includes(mediaContext.filter)) {
            return _js('Images');
        }
        if (exports.MediaFilterNames.includes(mediaContext.filter)) {
            return _js('Media');
        }
        if (exports.DocumentFilterNames.includes(mediaContext.filter)) {
            return _js('Documents');
        }
    }
    return _js('All');
};
exports.tabTitleFromFilter = tabTitleFromFilter;
